var UILang = /** @class */ (function () {
    function UILang() {
    }
    UILang.core = {
        All: "All",
        Ok: "Ok",
        Cancel: "Cancel"
    };
    UILang.grid = {
        Sort: "Sort",
        Asc: "Ascending",
        Desc: "Descending",
        Filter: "Filter",
        ClearFilter: "Clear Filter",
        Search: "Search"
    };
    UILang.dropDown = {
        SelectOption: "Select an option...",
        SelectOptionMultiple: "Enter options...",
        NoResults: "No results",
        NoOptions: "No options available",
        MaxSelection: "A maximum of {max} items can be selected",
        AlreadyInUse: "That tag is already in use",
        Search: "Search ..."
    };
    return UILang;
}());
export { UILang };
